/** GridContainer parser: Control + column count. */
import { parseOptionalInt } from '../../../../parser/valueParsers';
import { parseControl } from '../control/parser';
export function parseGridContainer(heading, properties) {
    const result = { ...parseControl(heading, properties) };
    result.columns = parseOptionalInt(properties.columns);
    return result;
}
//# sourceMappingURL=parser.js.map